import React from "react";
import Table from "react-bootstrap/Table";
import moment from 'moment'
import 'moment/locale/es'

import Jumbo from "../../assets/img/promorec.svg";
import {config, getImgCustomer} from "../../config"

export const NombreTable = ({
  nombrePromocion,
  nombreCliente,
  promotion
}) => {
  moment.locale('es')
  console.log("Data Promocional Resumen:::: ")
  console.log(promotion)
  return (
		<div className='NombreTable NombreTableNew'>
			<Table>
				<tbody>
					<tr>
						<td>
							<h1>Nombre</h1>
							<p>{
							//data.cadena_details.name_promotion
							promotion.offer_data.promotion_name
							}</p>
						</td>
						<td>
							<h1>Oficinas</h1>
							<p>{promotion.offer_data.offices.split(',')
  							.map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
  							.join(', ')}</p>
						</td>
						<td>
							<h1>Fecha</h1>
							<p>
								{promotion.offer_data.month} {promotion.offer_data.end_sellin.split("/")[2]}
							</p>
						</td>
						<td>
							<h1>Fase</h1>
							<h1 className='badge_blue'>
								{promotion.offer_data.phase}
							</h1>
						</td>
						<td>
							<h1>Estado</h1>
							<h1 className='badge_blue'>
								{promotion.offer_data.state}
							</h1>
						</td>
					</tr>
				</tbody>
			</Table>

			<Table>
				<tbody>
					<td>
						<h1>Vigencia</h1>

						<p>
							In.{' '}
							<b>
								{ /*moment(promotion.start_sellin)
									.format('DD/MMM/YYYY')
									.replace(/\./g, '')
								*/
								promotion.offer_data.start_sellin
								}
							</b>{' '}
							<br />
							Te.{' '}
							<b>
								{ /*moment(promotion.end_sellin)
									.format('DD/MMM/YYYY')
							.replace(/\./g, '')*/ 
							promotion.offer_data.end_sellin
							}
							</b>
						</p>
					</td>
					
					<td>
						<h1>Número SKU</h1>

						<p>
							{promotion.data_rows.length} <br></br><br></br>
						</p>
					</td>

					<td>
						<h1>Número Act.</h1>

						<p>
							{promotion.data_rows.length}
						</p>
					</td>

					<td>
						<h1>Volumen Estr.</h1>

						<p>
							{promotion.header[0].strat_vol}
						</p>
					</td>
				</tbody>
			</Table>
		</div>
	)
};
